// Common helper to map Air Quality Index (AQI) values to status colors.
// Usage:
//   import { getAirQualityStatusColor } from '../../utils/air-quality';
//   const color = getAirQualityStatusColor(aqiValue);

export const getAirQualityStatusColor = (value) => {
  if (value !== null && value !== undefined && value !== '') {
    const num = Number(value);

    if (Number.isNaN(num)) {
      return '#00000080';
    }

    if (num >= 0 && num <= 50) {
      return '#59D678';
    } else if (num >= 51 && num <= 100) {
      return '#FBAE42';
    } else if (num >= 101 && num <= 150) {
      return 'orange';
    } else if (num >= 151 && num <= 200) {
      return 'red';
    } else if (num >= 201 && num <= 300) {
      return 'purple';
    }

    return 'maroon';
  }

  // Default / unknown color
  return '#00000080';
};

// Common helper to map Air Quality Index (AQI) values to textual status.
// Usage:
//   import { getAirQualityStatus } from '../../utils/air-quality';
//   const label = getAirQualityStatus(aqiValue);
export const getAirQualityStatus = (value) => {
  if (value !== null && value !== undefined && value !== '') {
    const num = Number(value);

    if (Number.isNaN(num)) {
      return '';
    }

    if (num >= 0 && num <= 50) {
      return 'Good';
    } else if (num >= 51 && num <= 100) {
      return 'Moderate';
    } else if (num >= 101 && num <= 150) {
      return 'Unhealthy';
    } else if (num >= 151 && num <= 200) {
      return 'Unhealthy';
    } else if (num >= 201 && num <= 300) {
      return 'V. Unhealthy';
    }
    return 'Hazardous';
  }

  return '';
};

